export default __webpack_public_path__ + "static/media/withdraw-reward-step2.e24f5a9e.png";